// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { UserManagementOrganizationAreaId } from './UserManagementOrganizationAreaId'
import { UserManagementOrganizationAreaNavigation } from './UserManagementOrganizationAreaNavigation'
import { UserManagementOrganizationAreaRoutes } from './UserManagementOrganizationAreaRoutes'

const LazyUserManagementOrganizationComponent = lazy(
  () => import('./UserManagementOrganizationArea'),
)

const UserManagementOrganizationComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyUserManagementOrganizationComponent />
  </SuspenseLoadingWrapper>
)

export const UserManagementOrganizationArea = {
  id: UserManagementOrganizationAreaId,
  NavigationComponent: UserManagementOrganizationAreaNavigation,
  route: {
    path: UserManagementOrganizationAreaRoutes.route,
    component: UserManagementOrganizationComponent,
  },
}
